// @wf-will-never-add-flow-to-this-file

import {emotionStyled} from '@packages/utilities/styled';
import {EmptyState} from '@packages/systems/spring';
import {brandedFontFamily} from '../../constants';

export const BrandedEmptyState = emotionStyled(EmptyState)(
  {
    fontFamily: brandedFontFamily,
    border: '1px dashed transparent',
    padding: '$6',
    '[data-size="x-large"]': {
      fontSize: '16px',
      fontWeight: 600,
    },
  },
  {
    variants: {
      isDropzone: {
        true: {
          border: '1px dashed $border3',
        },
      },
    },
  }
);

BrandedEmptyState.displayName = 'BrandedEmptyState';

export default BrandedEmptyState;
